/*
 * @Author: cheesekun
 * @Date: 2021-03-18 21:15:01
 * @LastEditors: cheesekun
 * @LastEditTime: 2021-03-18 21:16:04
 * @FilePath: \dc-wsy-sign-in-activity-horizontal-front\src\directive\fixed\fixed.js
 */
export default {
  // inserted 被绑定元素插入父节点时调用
  inserted () {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;'
  },
  // unbind 指令与元素解绑时调用
  unbind () {
    const body = document.body
    body.style.position = ''
    const top = body.style.top
    document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
    body.style.top = ''
  }
}
